import axios from 'axios'
import { api } from '../api'
import { createSelector } from 'reselect'
import managers from '../mocks/managers'
import schedule from '../mocks/schedule'
import orderslist1 from '../mocks/orders-list-event1'
import orderslist2 from '../mocks/orders-list-event2'

/**
 * Constants
 * */
export const moduleName = 'meeting'

export const START = '_START'
export const SUCCESS = '_SUCCESS'
export const ERROR = '_ERROR'
export const CLOSE = '_CLOSE'
export const OPEN = '_OPEN'

export const MEETING = `${moduleName}/MEETING`
export const MEETINGSLIST = `${moduleName}/MEETINGSLIST`
export const BROKERTOURSLIST = `${moduleName}/BROKERTOURSLIST`
export const MANAGERSLIST = `${moduleName}/MANAGERSLIST`
export const SCHEDULELIST = `${moduleName}/SCHEDULELIST`
export const RATING = `${moduleName}/RATING`
export const EDIT = `${moduleName}/EDIT`
export const CANCEL = `${moduleName}/CANCEL`
export const RESET = `${moduleName}/RESET`


const managersarr = localStorage.getItem('managers') && localStorage.getItem('managers') !== 'undefined' ? JSON.parse(localStorage.getItem('managers')) : null
//const schedulearr = localStorage.getItem('schedule') ? JSON.parse(localStorage.getItem('schedule')) : null


/**
 * Reducer
 * */
const defaultState = {
	loading: false,
	loaded: false,
    error: null,
    success: null,
    response: null,
    brokertours: null,
    managers: managersarr,
    schedule: null,
    rate: null, 
    rateId: null,        
    rated: null,
    edit: null,
    cancel: null
}

export default (state = defaultState, action) => {
    const { type, error, response } = action

    switch (type) {
        case MEETING + START:
            return { 
                ...state, 
                loading: true 
        }
        case MEETING + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                success: true
        }
        case MEETING + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
        }
        case MEETING + CLOSE:
            return { 
                ...state, 
                loaded: false,
                success: null,
                response: null,
                brokertours: null,
        }
        
        case MEETINGSLIST + START:
            return { 
                ...state, 
                loading: true 
        }
        case MEETINGSLIST + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                response: response
        }
        case MEETINGSLIST + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
        }

        
        case BROKERTOURSLIST + START:
            return { 
                ...state, 
                loading: true 
        }
        case BROKERTOURSLIST + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                brokertours: response
        }
        case BROKERTOURSLIST + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
        }

        case MANAGERSLIST + START:
            return { 
                ...state, 
                loading: true 
        }
        case MANAGERSLIST + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                managers: response
        }
        case MANAGERSLIST + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
        }

        case SCHEDULELIST + START:
            return { 
                ...state, 
                loading: true 
        }
        case SCHEDULELIST + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                schedule: response
        }
        case SCHEDULELIST + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
        }

        case RATING + OPEN:
            return { 
                ...state, 
                rate: true,
                rateId: response
        }
        case RATING + CLOSE:
            return { 
                ...state, 
                popup: false,
                rate: null,
                rateId: null, 
                rated: null
        }
        case RATING + START:
            return { 
                ...state, 
                loading: true 
        }

        case RATING + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                rated: true
        }
        case RATING + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
        }

        case EDIT + OPEN:
            return { 
                ...state, 
                edit: response
        }
        case EDIT + CLOSE:
            return { 
                ...state, 
                edit: null
        }
        case EDIT + START:
            return { 
                ...state, 
                loading: true 
        }
        case EDIT + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                success: true
        }
        case EDIT + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
        }

        case CANCEL + OPEN:
            return { 
                ...state, 
                cancel: response
        }
        case CANCEL + CLOSE:
            return { 
                ...state, 
                cancel: null
        }
        case CANCEL + START:
            return { 
                ...state, 
                loading: true 
        }
        case CANCEL + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                cancel: null
        }
        case CANCEL + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
        }
        case ERROR + OPEN:
            return { 
                ...state, 
                error
        }
        case ERROR + CLOSE:
            return { 
                ...state, 
                error: null
        }
        case RESET:
            return {
                ...state,
                loading: false,
                loaded: false,
                error: null,
                success: null,
                response: null,
                brokertours: null,
                schedule: null,
                rate: null,
                rateId: null,
                rated: null,
        }

        default:
            return state
    }
}

/**
 * Action Creators
 * */

export const getMeetingsList = (params) => async (dispatch) => {

    //return dispatch({ type: MEETINGSLIST + SUCCESS, response: orderslist1.content.OrdersList })

	dispatch({ type: MEETINGSLIST + START })
	try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString())
		//console.log(data);

		if (data.success) {
            dispatch({ 
                type: MEETINGSLIST + SUCCESS, 
                response: data.content.OrdersList
            })
        }
        if (data.error) {
            dispatch({ 
                type: MEETINGSLIST + ERROR,
                error: data.message
            })
        }
	} catch (error) {
		console.log(error);
	}
}

export const getBrokerToursList = (params) => async (dispatch) => {

    //return dispatch({ type: BROKERTOURSLIST + SUCCESS, response: orderslist2.content.OrdersList })

	dispatch({ type: BROKERTOURSLIST + START })
	try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString())
		//console.log(data);

		if (data.success) {
            dispatch({ 
                type: BROKERTOURSLIST + SUCCESS, 
                response: data.content.OrdersList
            })
        }
        if (data.error) {
            dispatch({ 
                type: BROKERTOURSLIST + ERROR,
                error: data.message
            })
        }
	} catch (error) {
		console.log(error);
	}
}

export const orderMeetingSend = (params) => async (dispatch) => {

	//return dispatch({ type: MEETING + SUCCESS })
	
	try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString())
		//console.log(data);

		if (data.success) {

			dispatch({ type: MEETING + SUCCESS,});
			
		} else if(data.error) {
			dispatch({
				type: MEETING + ERROR,
				error: data.message
			});			
		}
	} catch (error) {
		console.log(error)
		if (error.response)
			dispatch({
				type: MEETING + ERROR,
				error: error.response
			});
	}	
}


export const openMeetingEdit = (params) => dispatch => dispatch({ type: EDIT + OPEN, response: params })
export const closeMeetingEdit = (params) => dispatch => dispatch({ type: EDIT + CLOSE, response: params })

export const openMeetingCancel = (params) => dispatch => dispatch({ type: CANCEL + OPEN, response: params })
export const closeMeetingCancel = () => dispatch => dispatch({ type: CANCEL + CLOSE })

export const orderMeetingCancel = (params) => async (dispatch) => {

    dispatch({ type: CANCEL + START })

	//return dispatch({ type: CANCEL + SUCCESS })	
    
	try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString())
		//console.log(data);

		if (data.success) {
			dispatch({ type: CANCEL + SUCCESS});
			
		} else if(data.error) {
			dispatch({
				type: CANCEL + ERROR,
				error: data.message ? data.message : 'Пустое поле с ошибкой'
			});			
		}
	} catch (error) {
		console.log(error)
		if (error.response)
			dispatch({
				type: CANCEL + ERROR,
				error: error.response
			});
	}	
}

export const setManagers = (data) => async (dispatch) => {
    //if (data.success) {
        dispatch({ 
            type: MANAGERSLIST + SUCCESS, 
            response: data
        })
        localStorage.setItem("managers", JSON.stringify(data));
    //}
}
export const setSchedule = (data) => async (dispatch) => {
    //if (data.success) {
        dispatch({ 
            type: SCHEDULELIST + SUCCESS, 
            response: data
        })
        localStorage.setItem("schedule", JSON.stringify(data));
    //}
}
export const getManagers = (params) => async (dispatch) => {

    //let oldarr = JSON.parse(localStorage.getItem('managers')) || [];
    //managers.content.ManagersInfo.map((item) => !oldarr.some((obj) => obj.id === item.id) && oldarr.push({...item, projectId: params.projectId, typeId: params.typeId}));
    //localStorage.setItem("managers", JSON.stringify(oldarr));
    //return dispatch({ type: MANAGERSLIST + SUCCESS, response: managers.content.ManagersInfo })

	dispatch({ type: MANAGERSLIST + START })

	try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString())
		console.log(data);

		if (data.success) {
            let oldarr = JSON.parse(localStorage.getItem('managers')) || [];
            data.content.ManagersInfo.map((item) => !oldarr.some((obj) => obj.id === item.id) && oldarr.push({...item, projectId: params.projectId, typeId: params.typeId}));            
            let newarr = oldarr.filter((obj, idx, arr) => idx === arr.findIndex((t) => t.value === obj.value))
			localStorage.setItem("managers", JSON.stringify(newarr));
            dispatch({ 
                type: MANAGERSLIST + SUCCESS, 
                response: newarr
            })
        }
        if (data.error) {
            dispatch({ 
                type: MANAGERSLIST + ERROR,
                error: data.message
            })
			localStorage.removeItem("managers");	
        }
	} catch (error) {
		console.log(error);
        if (error.response)
            dispatch({
                type: MANAGERSLIST + ERROR,
                error: error.response
            });
            localStorage.removeItem("managers");
	}
}

export const getSchedule = (params) => async (dispatch) => {
    
    //let oldarr = JSON.parse(localStorage.getItem('schedule')) || [];
    //schedule.content.TimeslotInfo.map((item) => !oldarr.some((obj) => obj.id === item.id) && oldarr.push({...item, managerId: params.managerId}));
    //localStorage.setItem("schedule", JSON.stringify(oldarr));
    //return dispatch({ type: SCHEDULELIST + SUCCESS, response: schedule.content.TimeslotInfo })

	dispatch({ type: SCHEDULELIST + START })
    
	try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString())
		if (data.success) {
            /*let oldarr = JSON.parse(localStorage.getItem('schedule')) || [];
            //data.content.TimeslotInfo.map((item) => !oldarr.some((obj) => obj.id === item.id) && oldarr.push({...item, managerId: params.managerId}));
            let newData = data.content.TimeslotInfo.map((item) => {                
                item.managerId = params.managerId
                item.eventTypeId = params.eventTypeId
                item.formatId = params.formatId
                return item
            })
            console.log("+++++++++++++++++++++++++++++++")            
            if(oldarr[params.managerId] === undefined) oldarr[params.managerId] = {}
            if(oldarr[params.managerId][params.eventTypeId] === undefined) oldarr[params.managerId][params.eventTypeId] = {}
            if(oldarr[params.managerId][params.eventTypeId][params.formatId] === undefined) oldarr[params.managerId][params.eventTypeId][params.formatId] = {}
            oldarr[params.managerId][params.eventTypeId][params.formatId] = newData
            console.log('localStorage', oldarr)
			localStorage.setItem("schedule", JSON.stringify(oldarr));*/
            dispatch({ 
                type: SCHEDULELIST + SUCCESS, 
                response: data.content.TimeslotInfo
            })
        }
        if (data.error) {
            dispatch({ 
                type: SCHEDULELIST + ERROR,
                error: data.message
            })
        }
	} catch (error) {
		console.log(error);
	}
}


export const clearMeeting = () => dispatch => dispatch({ type: MEETING + CLOSE })

export const cancelMeeting = () => dispatch => dispatch({ type: MEETING + CLOSE })


export const openRatingPopup = (params) => dispatch => dispatch({ type: RATING + OPEN, response: params.id })
export const closeRatingPopup = () => dispatch => dispatch({ type: RATING + CLOSE })

export const ratingSend = (params) => async (dispatch) => {

	//dispatch({ type: RATING + START })
	
	try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString())
		//console.log(data);

		if (data.success) {
			dispatch({ type: RATING + SUCCESS,});
			
		} else if(data.error) {
			dispatch({
				type: RATING + ERROR,
				error: data.message
			});			
		}
	} catch (error) {
		console.log(error)
		if (error.response)
			dispatch({
				type: RATING + ERROR,
				error: error.response
			});
	}	
}
 
export const openErrorMsg = (params) => dispatch => dispatch({ type: ERROR + OPEN, error: params.error })
export const closeErrorMsg = () => dispatch => dispatch({ type: ERROR + CLOSE })

/**
 * Selectors
 * */

export const selectMeetings = (state) => state.meeting.response;
export const selectBrokerTours = (state) => state.meeting.brokertours;
export const selectProjects = (state) => state.realty.projects;
export const selectTypes = (state) => state.realty.types;
export const selectManagers = (state) => state.meeting.managers;
export const selectDateTimes = (state) => state.meeting.schedule;
export const selectMeetingsList = createSelector(
    [
        selectMeetings,
        selectProjects,
        selectTypes,
        selectManagers
    ],
    (meetings, projects, types, managers) => {
        
        if(meetings && projects && types && managers) {
            //console.log(meetings)
            let expandedArray = meetings.map(meet => {
                let project = projects.filter(obj => obj.id === meet.projectId)
                let type = types.filter(obj => obj.id === meet.typeId)
                return (
                    { 
                        ...meet, 
                        project: project.length ? project[0].name : '',  
                        type: type.length ? type[0].name : '', 
                    }
                )
            });

           return expandedArray
        }
    }
)
  
export const selectBrokerToursList = createSelector(
    [
        selectBrokerTours,
        selectProjects,
        selectTypes,
        selectManagers
    ],
    (brokertours, projects, types, managers) => {
        
        if(brokertours && projects && types && managers) {
            
            let expandedArray = brokertours.map(meet => {
                let project = projects.filter(obj => obj.id === meet.projectId)
                let type = types.filter(obj => obj.id === meet.typeId)                
                return (
                    { 
                        ...meet, 
                        project: project.length ? project[0].name : '',  
                        type: type.length ? type[0].name : '', 
                    }
                )
            });

           return expandedArray
        }
    }
)

  
export const resetStore = () => async (dispatch) => dispatch({ type: RESET })